/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Divider, Flex, Heading, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
/* Styles */
import SilentUnderCurrentSt from '@moms/styleData/SilentUnderCurrentSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const SilentUnderCurrent = ({ sectionContent, region, lang }) => {
  const MainUi = ({ region, lang, sectionContent }) => {
    return (
      <Box w="100%" maxW={1200} mx="auto">
        <Flex flexDir={{ base: 'column', md: 'row' }} flexWrap="wrap">
          <Box w={{ base: '100%', md: 345 }}>
            <SecHeading
              title={sectionContent[0].titleText}
              subText={sectionContent[0].titleSubtext}
            />
          </Box>
          <Flex
            mt={{ base: '45px', md: '0' }}
            flexDir={{ base: 'column-reverse', md: 'row' }}
            flexWrap="wrap"
          >
            {sectionContent[1].cards.map((card, index) => (
              <Card card={card} key={index} />
            ))}
          </Flex>
        </Flex>
      </Box>
    );
  };

  const SecHeading = ({ title, subText }) => {
    return (
      <Box pt="50px" px="1rem">
        <Heading textAlign="left" {...SilentUnderCurrentSt[lang].title}>
          {title}
        </Heading>
        <Heading textAlign="left" {...SilentUnderCurrentSt[lang].titleSubText}>
          {subText}
        </Heading>
      </Box>
    );
  };
  const Card = ({ card }) => {
    return (
      <Box
        backgroundImage={card.thumbnail.url}
        bgPos="top center"
        backgroundSize={{ base: 'contain', md: 'cover' }}
        flex={1}
        bgRepeat="no-repeat"
        pb={{ base: '65px', md: '40px' }}
        // maxW={{ base: '175px', md: 'none' }}
        mx={{ base: 'auto', md: '0' }}
        w={{ base: '100%', md: '275px' }}
        borderLeft={{
          base: '1px solid transparent',
          md: '1px solid rgba(255, 255, 255, 0.20)',
        }}
        borderTop={{
          base: '1px solid rgba(255, 255, 255, 0.20)',
          md: '1px solid transparent',
        }}
      >
        <Flex
          alignItems="center"
          textAlign="center"
          flexDir="column"
          pt="245px"
        >
          <Heading
            {...SilentUnderCurrentSt[lang].cardHeading}
            sx={{
              em: {
                ...SilentUnderCurrentSt[lang].emHeading,
              },
            }}
          >
            {parser(card.title)}
          </Heading>
          <Text {...SilentUnderCurrentSt[lang].cardSession}>
            {card.sessions}
          </Text>
          <StructuredTextParser
            region={region}
            lang={lang}
            textAlign="center"
            w={{ base: '175px', sm: '230px' }}
            mt={{ base: '20px', md: '75px' }}
            str={render(card.description)}
            {...SilentUnderCurrentSt[lang].cardDesc}
          />
          <Divider
            bg="rgba(255, 255, 255, 0.20)"
            height="1px"
            w="175px"
            mx="auto"
            my="10px"
          />
          <Text w={{ base: '175px' }} {...SilentUnderCurrentSt[lang].cardText}>
            {card.rightAlignedText}
          </Text>
        </Flex>
      </Box>
    );
  };
  return (
    <Box
      w="100%"
      borderTop="1px solid rgba(255, 255, 255, 0.20)"
      borderBottom="1px solid rgba(255, 255, 255, 0.20)"
    >
      {/* main ui */}
      <MainUi region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

export default SilentUnderCurrent;
